const VARIANT_ORDER = ["desktop", "tablet", "mobile"];
const VARIANT_DIMENSIONS = {
  mobile: 480,
  tablet: 960,
  desktop: 1400,
};

export function buildVariantSrcSet(variants) {
  if (!variants) return null;
  return VARIANT_ORDER.map((name) => {
    const variant = variants[name];
    if (!variant?.url) return null;
    const width = variant.width || VARIANT_DIMENSIONS[name];
    return `${variant.url} ${width}w`;
  })
    .filter(Boolean)
    .join(", ");
}

export function getVariantSizes(srcSet) {
  if (!srcSet) return undefined;
  return "(max-width: 600px) 480px, (max-width: 1200px) 960px, 1400px";
}

export function selectPreferredVariantUrl(variants) {
  if (!variants) return null;
  for (const name of VARIANT_ORDER) {
    if (variants[name]?.url) {
      return variants[name].url;
    }
  }
  return null;
}
